import { Box, Card, Grid2, MenuItem, Typography } from "@mui/material";
import { React, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import ContractIco from "../../../assets/icons/ContractIco";
import DollarIco from "../../../assets/icons/DollarIco";
import FullTimeIco from "../../../assets/icons/FullTimeIco";
import JobMapDoneIco from "../../../assets/icons/JobMapDoneIco";
import JobMapProgressIco from "../../../assets/icons/JobMapProgressIco";
import JobMapVetorIco from "../../../assets/icons/JobMapVetorIco";
import JobMapWarningIco from "../../../assets/icons/JobMapWarningIco";
import PauseIco from "../../../assets/icons/PauseIco";
import PlayTimeIco from "../../../assets/icons/PlayTimeIco";
import StatusChangeIco from "../../../assets/icons/StatusChangeIco";
import ShortlistedImage from "../../../assets/images/Shortlisted.png";
import SubtractImage from "../../../assets/images/Subtract.png";
import TotalApplicantsImage from "../../../assets/images/TotalApplicants.png";
import CommonButton from "../../../component/Button";
import CommonLinearProgress from "../../../component/Linearprogress";
import DropDownSelect from "../../../component/Select";
import SnackBar from "../../../component/SnackBar";
import { AddToJobPool } from "../../../redux/action/Candidate";
import {
  DraftToActivate,
  JobJobShare,
  RequestInfoToLiveScreen,
  ScoreToRequestInfo,
  WorkFlowManagement,
} from "../../../redux/action/Job";
import {
  JobPauseAutomation,
  JobResumeAutomation,
  JobStatusTracker,
} from "../../../redux/action/JobMap";
import { UploadJob } from "../../../redux/action/QuickMatch";
import { CreateSubmissionDocument } from "../../../redux/action/Submission";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
  StyledFlexColumnView,
  TitleTypo,
} from "../../common-components/StyledComponents";
import AddMoreCandidate from "../../matches/quick-match/components/AddMoreCandidate";
import ShareQuickMatch from "../../matches/quick-match/components/ShareQuickMatch";
import {
  FileContainer,
  StyledLinearContainer,
} from "../../matches/quick-match/components/StyledComponent";
import DialogCandidateHub from "../jobs-candidate/components/DialogCandidateHub";
import { CustomizeSpan, CustomTooltipField } from "../style";
import { useNavigate } from "react-router-dom";

export default function JobKrystalPath() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const workFlowManagementData = useSelector(
    (state) => state.jobs.workFlowManagement
  );

  const storedData = JSON.parse(localStorage.getItem("workflow_score"));
  const [isLoading, setIsLoading] = useState(false);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [shareDialogOpen, setShareDialogOpen] = useState({
    open: false,
    loading: false,
  });
  const [uploadFile, setUploadFile] = useState({
    drag: false,
    files: [],
    open: false,
    loading: false,
  });
  const allowedTransitions = {
    draft_stage: ["active_stage"],
    active_stage: ["share_stage"],
    share_stage: ["resume_score_stage"],
    resume_score_stage: ["coversheet_stage"],
    coversheet_stage: ["live_screen_stage"],
    live_screen_stage: ["submission_stage"],
  };
  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const statusOptions = [
    {
      name: "Internal Recruiter",
      value: "internal_recruiter",
    },
    { name: "External Recruiter", value: "external_recruiter" },
    { name: "External vendor", value: "external_vendor" },
  ];
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const gridData = [
    {
      title: "Agency",
      contentKey: `${localStorageData.organization}`,
    },
    { title: "Display Jobs", contentKey: "All Clients" },
    // { title: "Openings", contentKey: "16" },
  ];
  const [selectDialog, setSelectDialog] = useState({
    open: false,
    disabled: false,
    loading: false,
    value: "",
  });
  const [pausePlayDialog, setPausePlayDialog] = useState({
    open: false,
    disabled: false,
    yesLoading: false,
    noLoading: false,
    content: "",
    value: "",
  });
  const [managementData, setManagementData] = useState({
    loading: true,
    total_jem: 0,
    prev_data: {},
    data: {
      draft_stage: {
        title: "Draft",
        backgroundImage: TotalApplicantsImage,

        items: [],
      },
      active_stage: {
        title: "Activated",
        backgroundImage: ShortlistedImage,
        items: [],
      },
      share_stage: {
        title: "Share",
        backgroundImage: ShortlistedImage,
        items: [],
      },

      resume_score_stage: {
        title: "Source and Score",
        backgroundImage: ShortlistedImage,
        items: [],
      },
      coversheet_stage: {
        title: "Request Information",
        backgroundImage: ShortlistedImage,
        items: [],
      },
      live_screen_stage: {
        title: "Live Screen Stage",
        backgroundImage: ShortlistedImage,
        items: [],
      },
      submission_stage: {
        title: "Submission",
        backgroundImage: SubtractImage,
        items: [],
      },
    },
    type: "",
  });

  const CustomMenuItem = (item, index) => {
    return (
      <MenuItem value={item} key={index}>
        {item?.name}
      </MenuItem>
    );
  };

  const fetchStatusTracker = async () => {
    try {
      setIsLoading(true);
      setManagementData((prev) => ({
        ...prev,
        loading: true,
      }));

      const getData = await JobStatusTracker();
      setManagementData((prev) => ({
        ...prev,
        loading: false,
        total_jem: getData.data.total_jem,
        data: {
          ...prev.data,
          draft_stage: {
            ...prev.data.draft_stage,
            items: getData.data.draft_stage,
          },
          active_stage: {
            ...prev.data.active_stage,
            items: getData.data.active_stage,
          },
          share_stage: {
            ...prev.data.share_stage,
            items: getData.data.share_stage,
          },
          resume_score_stage: {
            ...prev.data.resume_score_stage,
            items: getData.data.resume_score_stage,
          },
          coversheet_stage: {
            ...prev.data.coversheet_stage,
            items: getData.data.coversheet_stage,
          },
          live_screen_stage: {
            ...prev.data.live_screen_stage,
            items: getData.data.live_screen_stage,
          },
          submission_stage: {
            ...prev.data.submission_stage,
            items: getData.data.submission_stage,
          },
        },
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setManagementData((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
    }
  };

  useEffect(() => {
    const data =
      Object.values(workFlowManagementData) &&
      Object.values(workFlowManagementData).length !== 0 &&
      Object.values(workFlowManagementData.data).some((stage) =>
        stage.items.some((item) => {
          return item.files;
        })
      );
    if (data) {
      setManagementData(workFlowManagementData);
    } else {
      fetchStatusTracker();
    }
  }, []);

  useEffect(() => {
    const data = Object.values(workFlowManagementData).length !== 0;
    if (data) {
      setManagementData(workFlowManagementData);

      if (
        workFlowManagementData &&
        workFlowManagementData.type &&
        workFlowManagementData.type.destination.droppableId !== "share_stage" &&
        workFlowManagementData.type.destination.droppableId !==
          "submission_stage" &&
        workFlowManagementData.type.destination.droppableId !==
          workFlowManagementData.type.source.droppableId
      ) {
        const checkData =
          Object.values(workFlowManagementData) &&
          Object.values(workFlowManagementData).length !== 0 &&
          Object.values(workFlowManagementData.data).some((stage) =>
            stage.items.some((item) => {
              return item.files;
            })
          );

        if (!checkData) {
          fetchStatusTracker();
        }
      }
    }
  }, [workFlowManagementData]);

  const commonFunction = ({ source, destination, result }) => {
    setManagementData((prev) => {
      const sourceList = [...prev.data[source.droppableId].items];
      const [movedItem] = sourceList.splice(source.index, 1);

      const destinationList =
        source.droppableId === destination.droppableId
          ? sourceList
          : [...prev.data[destination.droppableId].items];

      destinationList.splice(destination.index, 0, movedItem);

      const updatedData = {
        ...prev.data,
        [source.droppableId]: {
          ...prev.data[source.droppableId],
          items: sourceList,
        },
        [destination.droppableId]: {
          ...prev.data[destination.droppableId],
          items: destinationList,
        },
      };
      dispatch(
        WorkFlowManagement({
          ...prev,
          prev_data: prev.data,
          data: updatedData,
          files: [],
          dropData: movedItem,
          type: result,
        })
      );
      return {
        ...prev,
        prev_data: prev.data,
        data: updatedData,
        dropData: movedItem,
        type: result,
      };
    });
  };

  const handleDragEnd = async (result) => {
    const { source, destination } = result;

    if (!destination) return;

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }

    if (source.droppableId !== destination.droppableId) {
      const allowed = allowedTransitions[source.droppableId] || [];
      if (!allowed.includes(destination.droppableId)) {
        setSnackbarState({
          open: true,
          message: `Move not allowed: ${source.droppableId} → ${destination.droppableId}`,
          severity: "error",
        });
        return;
      }
    }
    if (destination.droppableId === source.droppableId) {
      return setManagementData((prev) => {
        const sourceList = [...prev.data[source.droppableId].items];
        const [movedItem] = sourceList.splice(source.index, 1);

        const destinationList =
          source.droppableId === destination.droppableId
            ? sourceList
            : [...prev.data[destination.droppableId].items];

        destinationList.splice(destination.index, 0, movedItem);

        let updatedData = {
          ...prev.data,
          [source.droppableId]: {
            ...prev.data[source.droppableId],
            items: sourceList,
          },
          [destination.droppableId]: {
            ...prev.data[destination.droppableId],
            items: destinationList,
          },
        };
        dispatch(
          WorkFlowManagement({
            ...prev,
            prev_data: prev.data,
            data: updatedData,
            type: result,
          })
        );
        return {
          ...prev,
          prev_data: prev.data,
          data: updatedData,
          files: [],
          type: result,
        };
      });
    } else if (
      destination.droppableId === "share_stage" &&
      source.droppableId !== destination.droppableId
    ) {
      setShareDialogOpen({ open: true, loading: false });
      commonFunction({ source, destination, result });
    } else if (
      destination.droppableId === "resume_score_stage" &&
      source.droppableId !== destination.droppableId
    ) {
      const sourceList = [...managementData.data[source.droppableId].items];
      const [movedItem] = sourceList.splice(source.index, 1);

      if (movedItem.resume_list && movedItem.resume_list.length === 0) {
        const destinationList =
          source.droppableId === destination.droppableId
            ? sourceList
            : [...managementData.data[destination.droppableId].items];

        destinationList.splice(destination.index, 0, movedItem);

        let updatedData = {
          ...managementData.data,
          [source.droppableId]: {
            ...managementData.data[source.droppableId],
            items: sourceList,
          },
          [destination.droppableId]: {
            ...managementData.data[destination.droppableId],
            items: destinationList,
          },
        };

        const newState = {
          ...managementData,
          prev_data: managementData.data,
          data: updatedData,
          dropData: movedItem,
          type: result,
        };
        setManagementData(newState);
        setUploadFile((prev) => ({
          ...prev,
          open: true,
          drag_drop: newState,
          dropData: movedItem,
        }));
      } else {
        const sourceList = [...managementData.data[source.droppableId].items];
        const [movedItem] = sourceList.splice(source.index, 1);

        const movedItemWithProgress = {
          ...movedItem,
          files: movedItem.resume_list.map((item) => ({
            ...item,
            ...movedItem,
            name: item.current_resume,
            progress: 0,
          })),
        };

        const destinationList =
          source.droppableId === destination.droppableId
            ? sourceList
            : [...managementData.data[destination.droppableId].items];

        destinationList.splice(destination.index, 0, movedItemWithProgress);

        let updatedData = {
          ...managementData.data,
          [source.droppableId]: {
            ...managementData.data[source.droppableId],
            items: sourceList,
          },
          [destination.droppableId]: {
            ...managementData.data[destination.droppableId],
            items: destinationList,
          },
        };

        for (const stageId in updatedData) {
          updatedData[stageId] = {
            ...updatedData[stageId],
            items: updatedData[stageId].items.map((item) => ({
              ...item,
              disabled: true,
            })),
          };
        }

        const newState = {
          ...managementData,
          prev_data: managementData.data,
          data: updatedData,
          type: result,
          dropData: movedItem,
        };

        setManagementData(newState);
        dispatch(
          WorkFlowManagement({
            ...newState,
            files: movedItemWithProgress.files,
            type: result,
          })
        );
        localStorage.setItem(
          "workflow_score",
          JSON.stringify({
            ...storedData,
            ...newState,
            files: movedItemWithProgress.files,
          })
        );
        handleL2Process();
      }
    } else if (
      destination.droppableId === "submission_stage" &&
      source.droppableId !== destination.droppableId
    ) {
      setSelectDialog((prev) => ({
        ...prev,
        open: true,
      }));

      commonFunction({ source, destination, result });
    } else {
      const sourceList = [...managementData.data[source.droppableId].items];
      const [movedItem] = sourceList.splice(source.index, 1);

      const movedItemWithProgress = {
        ...movedItem,
        files: [
          {
            ...movedItem,
            progress: 50,
          },
        ],
      };

      const destinationList =
        source.droppableId === destination.droppableId
          ? sourceList
          : [...managementData.data[destination.droppableId].items];

      destinationList.splice(destination.index, 0, movedItemWithProgress);

      let updatedData = {
        ...managementData.data,
        [source.droppableId]: {
          ...managementData.data[source.droppableId],
          items: sourceList,
        },
        [destination.droppableId]: {
          ...managementData.data[destination.droppableId],
          items: destinationList,
        },
      };

      for (const stageId in updatedData) {
        updatedData[stageId] = {
          ...updatedData[stageId],
          items: updatedData[stageId].items.map((item) => ({
            ...item,
            disabled: true,
          })),
        };
      }

      const newState = {
        ...managementData,
        prev_data: managementData.data,
        data: updatedData,
        type: result,
      };

      setManagementData(newState);
      dispatch(
        WorkFlowManagement({
          ...newState,
          files: movedItemWithProgress.files,
          type: result,
        })
      );

      try {
        let activeJobData;
        if (result.destination.droppableId === "active_stage") {
          activeJobData = await DraftToActivate(movedItem.id);
        } else if (result.destination.droppableId === "live_screen_stage") {
          let payload = {
            job_id: movedItem.id,
          };
          activeJobData = await RequestInfoToLiveScreen(payload);
        } else if (result.destination.droppableId === "submission_stage") {
          activeJobData = await CreateSubmissionDocument(movedItem.id);
        } else if (result.destination.droppableId === "coversheet_stage") {
          let payload = {
            id: movedItem.id,
          };
          activeJobData = await ScoreToRequestInfo(payload);
        }

        await handleWorkFlowUpdate(newState, destination, result);

        setSnackbarState({
          open: true,
          message: activeJobData.message,
          severity: "success",
        });
      } catch (error) {
        handleDropError({
          managementData,
          source,
          result,
          error,
        });
      }
    }
  };

  const handleWorkFlowUpdate = (newState, destination, result) => {
    const currentState = newState;
    const updatedData = { ...currentState.data };
    const destinationItems = [...updatedData[destination.droppableId].items];
    const itemIndex = destination.index;

    if (destinationItems[itemIndex]) {
      destinationItems[itemIndex] = {
        ...destinationItems[itemIndex],
        disabled: true,
        files: [
          {
            ...destinationItems[itemIndex],
            progress: 100,
            disabled: true,
          },
        ],
      };
      updatedData[destination.droppableId] = {
        ...updatedData[destination.droppableId],
        items: destinationItems,
      };
    }

    dispatch(
      WorkFlowManagement({
        ...currentState,
        data: updatedData,
        files: destinationItems[itemIndex]?.files || [],
        type: result,
      })
    );

    setManagementData((prev) => ({
      ...prev,
      data: updatedData,
      type: result,
    }));

    setTimeout(() => {
      const cleanedData = {};
      for (const stageId in updatedData) {
        cleanedData[stageId] = {
          ...updatedData[stageId],
          items: updatedData[stageId].items.map(
            ({ files, disabled, ...rest }) => rest
          ),
        };
      }

      dispatch(
        WorkFlowManagement({
          ...currentState,
          data: cleanedData,
          files: [],
        })
      );

      setManagementData((prev) => ({
        ...prev,
        data: cleanedData,
        files: [],
        type: result,
      }));
    }, 1000);
  };

  const handleDropError = ({ managementData, source, result, error }) => {
    const currentState = managementData;
    const updatedData = { ...currentState.data };

    const sourceItems = [...updatedData[source.droppableId].items];
    const itemIndex = source.index;

    if (sourceItems[itemIndex]) {
      sourceItems[itemIndex] = {
        ...sourceItems[itemIndex],
        disabled: true,
        files: [
          {
            ...sourceItems[itemIndex],
            disabled: true,
            visible: true,
          },
        ],
      };

      updatedData[source.droppableId] = {
        ...updatedData[source.droppableId],
        items: sourceItems,
      };
    }

    const errorState = {
      ...currentState,
      data: updatedData,
      files: sourceItems[itemIndex]?.files || [],
      type: result,
    };

    dispatch(WorkFlowManagement(errorState));
    setManagementData(errorState);

    setSnackbarState({
      open: true,
      message: error.message,
      severity: "error",
    });

    setTimeout(() => {
      const cleanedData = {};
      for (const stageId in currentState.data) {
        cleanedData[stageId] = {
          ...currentState.data[stageId],
          items: currentState.data[stageId].items.map(
            ({ files, disabled, visible, ...rest }) => rest
          ),
        };
      }

      const finalState = {
        ...currentState,
        data: cleanedData,
        files: [],
        type: result,
      };
      dispatch(WorkFlowManagement(finalState));
      setManagementData(finalState);
    }, 2000);
  };

  const handleL2Process = async () => {
    const storedData = JSON.parse(localStorage.getItem("workflow_score"));
    const payload = {
      job: storedData.dropData.id,
      resumes: storedData.dropData.resume_list.map((item) => item.id),
    };

    try {
      const response = await AddToJobPool(payload);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse);
          } catch (e) {
            const storedData = JSON.parse(
              localStorage.getItem("workflow_score")
            );
            handleUploadError(
              storedData,
              "Error parsing JSON",
              jsonResponse.data
            );
          }
        }
      }

      if (buffer) {
        const jsonResponse = JSON.parse(buffer);
        try {
          await processJsonResponse(jsonResponse);
        } catch (e) {
          const storedData = JSON.parse(localStorage.getItem("workflow_score"));
          handleUploadError(storedData, "Error parsing final JSON chunk", null);
        }
      }
    } catch (error) {
      const storedData = JSON.parse(localStorage.getItem("workflow_score"));
      handleUploadError(storedData, "Error during the request", null);
    }
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen({ open: false, loading: false });
    if (!shareDialogOpen.loading) {
      setManagementData((prev) => ({
        ...prev,
        data: prev.prev_data,
      }));
    }
  };

  const handleShareInvite = async (shareData) => {
    setShareDialogOpen((prev) => ({ ...prev, loading: true }));
    try {
      let url = process.env.REACT_APP_URL;
      let payload = {
        job_id: managementData?.dropData?.id,
        url: `${url}/jobs/jobs-view?id=${managementData?.dropData?.id}&title=${managementData?.dropData?.job_title}&value=1`,
        to_mail: shareData,
        cc_mail: [],
        is_manual: true,
        job_name: managementData?.dropData?.job_title || "",
      };
      const jobShareData = await JobJobShare(
        payload,
        "Job",
        managementData?.dropData?.id
      );
      fetchStatusTracker();
      setSnackbarState({
        open: true,
        message: jobShareData.message,
        severity: "success",
      });
      setShareDialogOpen({ open: false, loading: false });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setShareDialogOpen((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles((prev) => ({
      ...prev,
      files: mergedFiles,
    }));

    const updated = {
      files: mergedFiles.map((f) => ({
        ...f,
        progress: 0,
        buffer: 0,
        visible: false,
        delete: false,
        file: {
          name: f.file.name,
          size: f.file.size,
          type: f.file.type,
          lastModified: f.file.lastModified,
          ...f.file,
        },
      })),
    };

    localStorage.setItem("workflow_score", JSON.stringify(updated));

    if (invalidFiles.length > 0) {
      setSnackbarState({
        open: true,
        message: `Unsupported file types: ${invalidFiles.join(", ")}`,
        severity: "error",
      });
    }
  };

  const handleAddMoreCandidateDialogClose = () => {
    setUploadFile((prev) => ({
      ...prev,
      open: false,
      files: [],
      drag: false,
    }));
    if (!uploadFile.loading) {
      setManagementData((prev) => ({
        ...prev,
        data: prev.prev_data,
      }));
    }
  };

  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setUploadFile,
      uploadFile.files
    );
  };

  const handleAddMoreCandidateDeleteFile = (index) => {
    setUploadFile((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  const handleAddMoreCandidateDragOver = (event) => {
    event.preventDefault();
    setUploadFile((prev) => ({
      ...prev,
      drag: true,
    }));
  };

  const handleAddMoreCandidateDragLeave = () => {
    setUploadFile((prev) => ({
      ...prev,
      drag: false,
    }));
  };

  const handleAddMoreCandidateDrop = (event) => {
    event.preventDefault();
    setIsLoading(false);
    setUploadFile((prev) => ({
      ...prev,
      drag: false,
    }));

    const droppedFiles = Array.from(event.dataTransfer.files);
    commonFileValidationCheck(
      droppedFiles,
      allowedTypes,
      setUploadFile,
      uploadFile.files
    );
  };

  const handleUploadError = (storedData, message, data) => {
    const updatedFiles = (storedData.files || []).map((f) => ({
      ...f,
      ...storedData.dropData,
      progress: data?.percent || 0,
      buffer: data?.buffer || 0,
      visible: true,
      delete: true,
      message: message,
    }));

    setUploadFile((prev) => ({
      ...prev,
      loading: false,
      files: updatedFiles,
    }));

    const stageId = "resume_score_stage";
    const rollback = storedData.prev_data || storedData.data;
    const updatedData = {};
    for (const sid in rollback) {
      updatedData[sid] = {
        ...rollback[sid],
        items: rollback[sid].items.map((item) => {
          if (sid === stageId && item.id === storedData.dropData.id) {
            return {
              ...item,
              files: updatedFiles,
              disabled: true,
            };
          }
          return { ...item, disabled: true };
        }),
      };
    }

    const errorState = {
      ...storedData,
      data: updatedData,
      files: updatedFiles,
    };

    dispatch(WorkFlowManagement(errorState));

    setTimeout(() => {
      const cleanedData = {};
      for (const sid in updatedData) {
        cleanedData[sid] = {
          ...updatedData[sid],
          items: updatedData[sid].items.map(
            ({ files, disabled, visible, message, ...rest }) => ({ ...rest })
          ),
        };
      }

      const finalState = {
        ...storedData,
        data: cleanedData,
        files: [],
      };

      localStorage.setItem("workflow_score", JSON.stringify(finalState));
      dispatch(WorkFlowManagement(finalState));
      setManagementData(finalState);
    }, 1000);

    setSnackbarState({
      open: true,
      message: message,
      severity: "error",
    });
  };

  const handleUploadClick = async () => {
    if (uploadFile.files.length === 0) {
      setSnackbarState((prev) => ({
        ...prev,
        open: true,
        message: "Upload the Files",
        severity: "error",
      }));
    } else {
      setUploadFile((prev) => ({
        ...prev,
        files: prev.files.map((f) => ({
          ...f,
          progress: 0,
          delete: false,
          buffer: 0,
        })),
        loading: true,
      }));

      const updatedData = {};
      for (const stageId in managementData.data) {
        updatedData[stageId] = {
          ...managementData.data[stageId],
          items: managementData.data[stageId].items.map((item) => {
            if (
              stageId === "resume_score_stage" &&
              item.id === uploadFile.dropData.id
            ) {
              return {
                ...item,
                files: uploadFile.files.map((file) => ({
                  name: file?.name || "",
                  size: file?.size || 0,
                  type: file?.type || "",
                  progress: 0,
                })),
                disabled: true,
              };
            }

            return {
              ...item,
              disabled: true,
            };
          }),
        };
      }

      const newState = {
        ...managementData,
        data: updatedData,
      };
      setManagementData(newState);
      localStorage.setItem(
        "workflow_score",
        JSON.stringify({
          ...newState,
          ...storedData,
          dropData: uploadFile.dropData,
        })
      );
      dispatch(
        WorkFlowManagement({
          ...newState,
          files: uploadFile.files.map((file) => ({
            ...uploadFile.dropData,
            name: file.name,
            size: file.size,
            type: file.type,
            progress: 0,
          })),
        })
      );
      const formData = new FormData();
      uploadFile.files.forEach((fileObj, index) => {
        formData.append("resume_file", fileObj.file);
      });
      formData.append("id", uploadFile?.dropData?.id);
      try {
        const response = await UploadJob(formData);
        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;
          const chunk = decoder.decode(value, { stream: true });
          buffer += chunk;
          let boundaryIndex;

          while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
            const jsonString = buffer.slice(0, boundaryIndex + 1);
            buffer = buffer.slice(boundaryIndex + 1);
            const jsonResponse = JSON.parse(jsonString);
            try {
              await processJsonResponse(jsonResponse);
            } catch (e) {
              const storedData = JSON.parse(
                localStorage.getItem("workflow_score")
              );
              handleUploadError(
                storedData,
                "Error parsing JSON",
                jsonResponse.data
              );
            }
          }
        }

        if (buffer) {
          const jsonResponse = JSON.parse(buffer);
          try {
            await processJsonResponse(jsonResponse);
          } catch (e) {
            const storedData = JSON.parse(
              localStorage.getItem("workflow_score")
            );
            handleUploadError(
              storedData,
              "Error parsing final JSON chunk",
              null
            );
          }
        }
      } catch (error) {
        const storedData = JSON.parse(localStorage.getItem("workflow_score"));
        handleUploadError(storedData, "Error during the request", null);
      }
    }
  };

  const processJsonResponse = (jsonResponse) => {
    const { success, data, message } = jsonResponse;

    const isClearFilesCase =
      success &&
      ((data && Object.keys(data)?.length === 0) ||
        (Array.isArray(data) && data.length !== 0 && data[0]?.id));

    if (success && data?.percent !== undefined) {
      const storedData = JSON.parse(localStorage.getItem("workflow_score"));
      const updatedFiles = (storedData.files || []).map((f) =>
        f.name === data.current_resume
          ? {
              ...f,
              ...storedData.dropData,
              progress: data.percent,
              buffer: data.buffer || data.percent,
              visible: false,
              delete: false,
              progress_message: data.progress_message,
            }
          : { ...f, ...storedData.dropData }
      );
      const updatedData = {};
      for (const stageId in storedData.data) {
        updatedData[stageId] = {
          ...storedData.data[stageId],
          items: storedData.data[stageId].items.map((item) => {
            if (
              stageId === "resume_score_stage" &&
              item.id === storedData.dropData.id
            ) {
              return {
                ...item,
                files: updatedFiles.map((f) =>
                  f.name === data.current_resume
                    ? {
                        ...f,
                        ...storedData.dropData,
                        progress: data.percent,
                        buffer: data.buffer || data.percent,
                        visible: false,
                        delete: false,
                        progress_message: data.progress_message,
                      }
                    : { ...f }
                ),
                disabled: true,
              };
            }
            return { ...item, disabled: true };
          }),
        };
      }
      const newState = {
        ...managementData,
        ...storedData,
        data: updatedData,
      };

      localStorage.setItem(
        "workflow_score",
        JSON.stringify({
          ...newState,
          files: updatedFiles,
        })
      );
      dispatch(
        WorkFlowManagement({
          ...newState,
          files: updatedFiles,
        })
      );
      setUploadFile((prev) => ({
        ...prev,
        ...storedData,
        files: updatedFiles,
        loading: true,
      }));
    } else if (isClearFilesCase) {
      const storedData = JSON.parse(localStorage.getItem("workflow_score"));

      const updatedData = {};
      for (const stageId in managementData.data) {
        updatedData[stageId] = {
          ...managementData.data[stageId],
          items: managementData.data[stageId].items.map((item) => {
            if (
              stageId === "resume_score_stage" &&
              item.id === storedData.dropData.id
            ) {
              return {
                ...item,
                files: [],
              };
            }
            return { ...item };
          }),
        };
      }
      const newState = {
        ...managementData,
        ...storedData,
        data: updatedData,
      };

      localStorage.setItem(
        "workflow_score",
        JSON.stringify({
          ...newState,
          files: [],
        })
      );
      dispatch(
        WorkFlowManagement({
          ...newState,
          files: [],
        })
      );
      setUploadFile((prev) => ({
        ...prev,
        ...storedData,
        files: [],
        loading: false,
        open: false,
      }));
      setSnackbarState({
        open: true,
        message: message,
        severity: "success",
      });
    } else if (!success) {
      const storedData = JSON.parse(localStorage.getItem("workflow_score"));
      handleUploadError(storedData, message, jsonResponse.data);
    }
  };

  const handleSelectChange = async () => {
    if (!selectDialog.value) {
      return;
    } else {
      let updatedData = { ...managementData.data };

      for (const stageId in updatedData) {
        updatedData[stageId] = {
          ...updatedData[stageId],
          items: updatedData[stageId].items.map((item) => {
            if (
              item.id === managementData.dropData.id &&
              stageId === "submission_stage"
            ) {
              return {
                ...item,
                disabled: true,
                files: [{ ...managementData.dropData, progress: 50 }],
              };
            }

            return {
              ...item,
              disabled: true,
            };
          }),
        };
      }

      const newState = {
        ...managementData,
        prev_data: managementData.prev_data,
        data: updatedData,
        type: managementData.type,
      };

      setManagementData(newState);

      dispatch(
        WorkFlowManagement({
          ...newState,
          files: updatedData.submission_stage?.items.flatMap(
            (i) => i.files || []
          ),
          type: managementData.type.result,
        })
      );
      try {
        setSelectDialog((prev) => ({
          ...prev,
          disabled: true,
          loading: true,
        }));
        const data = await CreateSubmissionDocument(
          selectDialog.value.value.id
        );
        await handleWorkFlowUpdate(
          newState,
          managementData.type.destination,
          managementData.type
        );
        fetchStatusTracker();
        setSelectDialog((prev) => ({
          ...prev,
          open: false,
          disabled: false,
          loading: false,
          value: "",
        }));
        setSnackbarState({
          open: true,
          message: data.data.message,
          severity: "success",
        });
      } catch (error) {
        await handleDropError({
          managementData,
          source: managementData.type.source,
          type: managementData.type,
          error,
        });
        setSelectDialog((prev) => ({
          ...prev,
          disabled: false,
          loading: false,
        }));
        fetchStatusTracker();
      }
    }
  };

  const ChangeStatusFooter = () => (
    <CommonButton
      value={"Select"}
      width={"100%"}
      padding={"10px"}
      marginTop={"2rem"}
      fontWeight={"700"}
      fontSize={"15px"}
      disabled={selectDialog.disabled}
      loading={selectDialog.loading}
      onClick={() => handleSelectChange()}
    />
  );

  const handleChangeStatusClose = () => {
    setSelectDialog((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      loading: false,
      value: "",
    }));
    if (!selectDialog.loading) {
      setManagementData((prev) => ({
        ...prev,
        data: prev.prev_data,
      }));
    }
  };

  const CustomDropDownMenuItem = (item, index) => {
    return (
      <MenuItem value={item} key={index}>
        {item?.candidate_name}
      </MenuItem>
    );
  };

  const handleContent = () => {
    return (
      <CommonGrid2 marginTop={"1rem"}>
        <DropDownSelect
          marginTop="0px"
          title={"Select Candidate"}
          removeAnimation={true}
          data={managementData.dropData && managementData.dropData.resume_list}
          valueChange={true}
          CustomMenuItem={CustomDropDownMenuItem}
          handleRenderValue={(selected) => {
            return selected;
          }}
          sizeMedium="0px"
          error={!selectDialog?.value}
          helperText={!selectDialog?.value && "Select the Candidate"}
          value={selectDialog.value && selectDialog.value.value.candidate_name}
          handleChange={(e) => {
            setSelectDialog((prev) => ({
              ...prev,
              value: e.target,
            }));
          }}
          customStyle={{
            "& .MuiSelect-select": {
              textAlign: "left",
            },
          }}
        />
      </CommonGrid2>
    );
  };

  const handlePlayBtn = (condition, card) => {
    setPausePlayDialog((prev) => ({
      ...prev,
      open: true,
      disabled: false,
      yesLoading: false,
      noLoading: false,
      value: card,
      condition: condition,
      content:
        condition === "pause"
          ? "Do you want to pause this Job's Automation?"
          : "Do you want to resume this Job's  Automation?",
    }));
  };

  const handleChangePausePlayClose = () => {
    setPausePlayDialog((prev) => ({
      ...prev,
      open: false,
      disabled: false,
      yesLoading: false,
      noLoading: false,
      value: "",
      content: "",
    }));
  };

  const handlePausePlayNoButton = () => {
    setPausePlayDialog((prev) => ({
      ...prev,
      disabled: true,
      noLoading: true,
    }));
    setTimeout(() => {
      handleChangePausePlayClose();
    }, 1000);
  };

  const handlePausePlayYesButton = async () => {
    setPausePlayDialog((prev) => ({
      ...prev,
      disabled: true,
      yesLoading: true,
    }));
    try {
      let payload;
      pausePlayDialog.condition === "start"
        ? (payload = {
            job_id: pausePlayDialog.value.id,
          })
        : (payload = {
            job_id: pausePlayDialog.value.id,
            type: "manual",
          });
      const data =
        pausePlayDialog.condition === "start"
          ? await JobResumeAutomation(payload)
          : await JobPauseAutomation(payload);
      fetchStatusTracker();
      handleChangePausePlayClose();
      setSnackbarState({
        open: true,
        message: data?.data?.message,
        severity: "success",
      });
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setPausePlayDialog((prev) => ({
        ...prev,
        disabled: false,
        yesLoading: false,
      }));
    }
  };

  const PausePlayFooter = () => (
    <CommonGrid2 display={"flex"} justifyContent={"space-between"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        variant="outlined"
        color="#344054"
        border={"#D0D5DD"}
        disabled={pausePlayDialog.disabled}
        loading={pausePlayDialog.noLoading}
        onClick={handlePausePlayNoButton}
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={pausePlayDialog.disabled}
        loading={pausePlayDialog.yesLoading}
        onClick={handlePausePlayYesButton}
      />
    </CommonGrid2>
  );

  const handleNavigate = (card, listId) => {
    if (listId === "draft_stage") {
      navigate(
        `/jobs/new-job?id=${card.id}&title=${card.job_title}&value=0&breadcrumbs=work_flow_management`
      );
    } else {
      navigate(
        `/jobs/jobs-view?id=${card.id}&title=${card.job_title}&value=1&breadcrumbs=work_flow_management`
      );
    }
  };
  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <CommonGrid2
        display={"flex"}
        flexWrap={"wrap"}
        justifyContent={"space-between"}
      >
        <Typography variant="h2">{"Workflow Management"}</Typography>
        <CommonButton
          value={"Add New Job"}
          padding={"10px 1.5rem"}
          onClick={() => navigate("/enrich-job")}
        />
      </CommonGrid2>

      <Box padding={"24px 0px"}>
        <Grid2
          container
          border={"1px solid #EAECF0"}
          borderRadius={"5px"}
          padding={
            managementData.loading || isLoading ? "0px 10px " : "10px 12px"
          }
          gap={"1rem"}
        >
          {gridData.map((item, index) =>
            managementData.loading || isLoading ? (
              <HandleSkeletion height={80} width={100} />
            ) : (
              <CommonGrid2 size={2} key={item.id}>
                <StyledFlexColumnView gap={"6px"}>
                  {item.title && (
                    <Typography
                      variant="subtitle2"
                      color={"#475467"}
                      fontWeight={500}
                    >
                      {item.title}
                    </Typography>
                  )}
                  {item.contentKey && (
                    <Typography
                      variant="body1"
                      color={"#101828"}
                      fontSize={14}
                      fontWeight={700}
                      textTransform="capitalize"
                    >
                      {item.contentKey}
                    </Typography>
                  )}
                </StyledFlexColumnView>
              </CommonGrid2>
            )
          )}
        </Grid2>
      </Box>

      <DragDropContext onDragEnd={handleDragEnd}>
        <CommonGrid2
          display={"flex"}
          scrollStyle
          overflowX={"auto"}
          scrollBar="5px"
          width={"100%"}
        >
          {Object.keys(managementData?.data).map((listId, getIndex) => {
            return (
              <Droppable key={listId} droppableId={listId}>
                {(provided, snapshot) => {
                  const sourceId = snapshot.draggingOverWith?.split("-")[0];
                  const isSameColumn = sourceId === listId;
                  const isAllowed =
                    isSameColumn ||
                    !sourceId ||
                    allowedTransitions[sourceId]?.includes(listId);
                  return (
                    <Box
                      ref={provided.innerRef}
                      {...provided.droppableProps}
                      sx={{
                        // background: "red",
                        width: {
                          xs: "300px",
                          sm: "300px",
                          md: "300px",
                          lg: "300px",
                          xl: "300px",
                        },
                        backgroundColor: snapshot.isDraggingOver
                          ? isAllowed
                            ? "#E0FFE0"
                            : "#FFE0E0"
                          : "transparent",
                        border: snapshot.isDraggingOver
                          ? isAllowed
                            ? "2px dashed green"
                            : "2px dashed red"
                          : "1px solid transparent",
                      }}
                    >
                      <Card
                        sx={{
                          position: "relative",
                          marginBottom: "16px",
                          //   padding: "20px",
                          backgroundColor: "transparent",
                          boxShadow: "unset",
                          borderRadius: "2px",
                          zIndex: 1,
                          width: {
                            xs: "220px",
                            sm: "220px",
                            md: "220px",
                            lg: "220px",
                            xl:
                              managementData.data[listId].items.length === 0
                                ? "220px"
                                : "100%",
                          },
                        }}
                      >
                        {managementData.loading || isLoading ? (
                          <HandleSkeletion height={50} width={"90%"} />
                        ) : (
                          <CommonGrid2
                            padding={"10px 10px 10px 20px"}
                            width={"171px"}
                          >
                            <Box
                              sx={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: -1,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={
                                  managementData.data[listId].backgroundImage
                                }
                                alt="Total Applicants"
                                style={{ width: "100%", height: "auto" }}
                              />
                            </Box>

                            <Typography variant="body2" color={"#5B738B"}>
                              {`${managementData.data[listId].title}`}
                            </Typography>
                            <TitleTypo
                              style={{
                                fontSize: "16px",
                                color: "#344054",
                                fontWeight: 700,
                                padding: "4px 0px",
                              }}
                            >
                              {`${managementData.data[listId].items.length}`}
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "#A9B4BE",
                                  fontWeight: 700,
                                  padding: "4px 0px",
                                }}
                              >
                                {" "}
                                /{managementData.total_jem}
                              </span>
                            </TitleTypo>
                          </CommonGrid2>
                        )}
                      </Card>
                      <Box
                        sx={{
                          //   maxHeight: {
                          //     xs: "none",
                          //     sm: "none",
                          //     md: "600px",
                          //     lg: "600px",
                          //     xl: "600px",
                          //   },
                          overflowY: "hidden",
                          height: "calc(100vh - 305px)",

                          "&:hover": {
                            overflowY: "auto",
                          },
                          "&::-webkit-scrollbar": {
                            width: "4px",
                          },
                          "&::-webkit-scrollbar-track": {
                            backgroundColor: "#f0f0f0",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#A9B4BE",
                            borderRadius: "4px",
                          },
                          marginLeft: managementData.data[listId]
                            .backgroundImage
                            ? "4px"
                            : "0",
                        }}
                      >
                        {managementData.loading || isLoading ? (
                          <HandleSkeletion
                            height={"calc(100vh - 285px)"}
                            width={"90%"}
                            transform="scale(1, 1)"
                          />
                        ) : (
                          managementData.data[listId].items.map(
                            (card, index) => {
                              return (
                                <Draggable
                                  key={card.unique_id}
                                  draggableId={`${listId}-${card.unique_id}=${card.req_id}`}
                                  index={index}
                                  isDragDisabled={
                                    card.is_automated || card.disabled
                                  }
                                >
                                  {(provided) => (
                                    <Card
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      sx={{
                                        marginBottom: "8px",
                                        padding: "10px",
                                        backgroundColor:
                                          card?.disabled || card.is_automated
                                            ? "#edeeee"
                                            : "#fff",
                                        boxShadow:
                                          "0px 0px 9.6px 0px #00000012",
                                        borderRadius: "5px",
                                        width: "97%",
                                        border: "1px solid #EAECF0",
                                        overflowX: "auto",

                                        "&:hover": {
                                          overflowY: "auto",
                                        },
                                        "&::-webkit-scrollbar": {
                                          height: "4px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                          backgroundColor: "#f0f0f0",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                          backgroundColor: "#A9B4BE",
                                          borderRadius: "4px",
                                        },
                                        cursor: snapshot.isDragging
                                          ? "grabbing"
                                          : "pointer !important",
                                      }}
                                      onClick={() =>
                                        handleNavigate(card, listId)
                                      }
                                    >
                                      {card.needs_attention && (
                                        <CommonGrid2
                                          display={"flex"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                          marginBottom={"4px"}
                                        >
                                          <CustomTooltip
                                            fontSize="12px"
                                            title={card.reason || "Job Paused"}
                                            placement="top"
                                          >
                                            <CommonGrid2
                                              display={"flex"}
                                              alignItems={"center"}
                                              gap={"5px"}
                                            >
                                              <JobMapWarningIco />

                                              <Typography
                                                variant="subtitle2"
                                                color={"#D55F00"}
                                                fontWeight={600}
                                              >
                                                {"Needs Attention"}
                                              </Typography>
                                            </CommonGrid2>
                                          </CustomTooltip>
                                        </CommonGrid2>
                                      )}

                                      {card.status && (
                                        <CommonGrid2
                                          display={"flex"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                          marginBottom={"4px"}
                                        >
                                          <CommonGrid2
                                            display={"flex"}
                                            alignItems={"center"}
                                            gap={"8px"}
                                          >
                                            {card.warning ? (
                                              <JobMapWarningIco />
                                            ) : card.status === "Inprogress" ? (
                                              <JobMapProgressIco />
                                            ) : (
                                              <JobMapDoneIco />
                                            )}
                                            <Typography
                                              variant="subtitle2"
                                              fontSize={"12px"}
                                              color={
                                                card.warning
                                                  ? "#D55F00"
                                                  : card.status === "Inprogress"
                                                  ? "#5B738B"
                                                  : "#17B26A"
                                              }
                                              fontWeight={600}
                                            >
                                              {card.status}
                                            </Typography>
                                          </CommonGrid2>
                                          <Typography
                                            variant="subtitle2"
                                            color={"#5B738B"}
                                            fontWeight={600}
                                            fontSize={"12px"}
                                          >
                                            {card.progress}
                                          </Typography>
                                        </CommonGrid2>
                                      )}

                                      {!(listId === "live_screen_stage" ||
                                      listId === "submission_stage") && (
                                        card.is_automated  ? (
                                          <CommonGrid2
                                            background="#F5F6F7"
                                            borderRadius="4px"
                                            padding="2px 8px"
                                            display={"flex"}
                                            gap={"8px"}
                                            alignItems={"center"}
                                            width={"max-content"}
                                            marginBottom={"8px"}
                                            cursor="pointer"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handlePlayBtn("pause", card);
                                            }}
                                          >
                                            <PlayTimeIco />
                                            <Typography
                                              variant="subtitle2"
                                              color={"#5B738B"}
                                              fontWeight={500}
                                            >
                                              Pause
                                              {/* <LiveTimer
                                                  startTime={card.time}
                                                /> */}
                                              {/* {hours12}:
                                      {minutes.toString().padStart(2, "0")}:
                                      {seconds.toString().padStart(2, "0")} */}
                                            </Typography>
                                          </CommonGrid2>
                                        ) : (
                                          <CommonGrid2
                                            background="#F1ECFF"
                                            borderRadius="4px"
                                            padding="2px 8px"
                                            display={"flex"}
                                            gap={"8px"}
                                            alignItems={"center"}
                                            width={"max-content"}
                                            marginBottom={"8px"}
                                            cursor="pointer"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handlePlayBtn("start", card);
                                            }}
                                          >
                                            <PauseIco />
                                            <Typography
                                              variant="subtitle2"
                                              color={"#5B738B"}
                                              fontWeight={500}
                                            >
                                              Start
                                              {/* {card.time} */}
                                            </Typography>
                                          </CommonGrid2>
                                        )
                                      )}

                                      <Typography
                                        variant="body2"
                                        color={"#344054"}
                                        margin={"0px 0px 4px"}
                                        fontSize={"12px"}
                                      >
                                        Unique ID :{" "}
                                        <CustomizeSpan fontWeight={700}>
                                          {card.unique_id}
                                        </CustomizeSpan>
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color={"#344054"}
                                        margin={"0px 0px 4px"}
                                        fontWeight={700}
                                        fontSize={"12px"}
                                      >
                                        {card.req_id}
                                      </Typography>
                                      <CommonGrid2
                                        display={"flex"}
                                        gap={"5px"}
                                        alignItems={"center"}
                                      >
                                        <CustomizeSpan
                                          variant="subtitle2"
                                          color={"#5B738B"}
                                          fontWeight={500}
                                          fontSize={"11px"}
                                        >
                                          {card.job_title}&nbsp;&nbsp;
                                          <CustomizeSpan
                                            variant="subtitle2"
                                            color={"#7F56D9"}
                                            fontSize={"11px"}
                                            fontWeight={700}
                                          >
                                            {card.client_name}
                                          </CustomizeSpan>
                                        </CustomizeSpan>
                                      </CommonGrid2>
                                      <CommonGrid2
                                        display={"flex"}
                                        gap={"8px"}
                                        marginTop={"6px"}
                                        justifyContent={"space-between"}
                                        width={"fit-content"}
                                      >
                                        {card.pay_rate && (
                                          <CommonGrid2
                                            background="#F5F6F7"
                                            borderRadius="4px"
                                            padding="2px 5px"
                                            display={"flex"}
                                            gap={"5px"}
                                            alignItems={"center"}
                                            width={"max-content"}
                                          >
                                            <CustomDiv display="flex">
                                              <DollarIco />
                                            </CustomDiv>

                                            <CustomizeSpan
                                              color={"#344054"}
                                              fontWeight={700}
                                              fontSize="12px"
                                            >
                                              {card.pay_rate}&nbsp;
                                            </CustomizeSpan>
                                          </CommonGrid2>
                                        )}
                                        <CommonGrid2
                                          background="#F5F6F7"
                                          borderRadius="4px"
                                          padding="2px 5px"
                                          display={"flex"}
                                          gap={"5px"}
                                          alignItems={"center"}
                                          width={"max-content"}
                                        >
                                          <CustomDiv display="flex">
                                            {card.employment_type ===
                                            "Contract" ? (
                                              <ContractIco />
                                            ) : (
                                              <FullTimeIco />
                                            )}
                                          </CustomDiv>
                                          <Typography
                                            variant="subtitle2"
                                            color={"#5B738B"}
                                            fontWeight={500}
                                          >
                                            {card.employment_type}
                                          </Typography>
                                        </CommonGrid2>
                                      </CommonGrid2>
                                      {card.scored_resumes && (
                                        <CommonGrid2
                                          display={"flex"}
                                          gap={"5px"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                          marginTop="5px"
                                        >
                                          <Typography
                                            color="#344054"
                                            fontSize={"12px"}
                                            fontWeight={500}
                                          >
                                            {"Resume"}
                                          </Typography>
                                          <Typography
                                            color={"#344054"}
                                            fontWeight={700}
                                            fontSize={"12px"}
                                          >
                                            {card.scored_resumes}/
                                            {card.total_resumes}
                                          </Typography>
                                        </CommonGrid2>
                                      )}
                                      {card.day && (
                                        <CommonGrid2
                                          display={"flex"}
                                          gap={"5px"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}
                                          marginTop="5px"
                                        >
                                          <Typography
                                            variant="subtitle1"
                                            color="#5B738B"
                                            fontSize={"12px"}
                                          >
                                            {card.day}
                                          </Typography>
                                          <CustomDiv>
                                            <JobMapVetorIco />
                                          </CustomDiv>
                                        </CommonGrid2>
                                      )}

                                      {card.files &&
                                        card.files.map((item) => (
                                          <FileContainer
                                            key={index}
                                            elevation={1}
                                            padding="10px"
                                            alignItems="center"
                                            borderRadius="8px"
                                            margin="10px 0px 0px"
                                            sx={{
                                              flexDirection: "column",
                                            }}
                                          >
                                            <Typography
                                              color="#344054"
                                              fontSize={"12px"}
                                              fontWeight={700}
                                              style={{
                                                wordBreak: "break-word",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                width: "180px",
                                              }}
                                            >
                                              {item.name || item.job_title}
                                            </Typography>
                                            <CommonGrid2
                                              display={"flex"}
                                              alignItems={"center"}
                                              gap={"10px"}
                                              width={"100%"}
                                              marginTop={"5px"}
                                            >
                                              <CustomDiv
                                                position="relative"
                                                width="100%"
                                              >
                                                <StyledLinearContainer>
                                                  <CommonLinearProgress
                                                    variant={
                                                      item.progress &&
                                                      !item.visible
                                                        ? "buffer"
                                                        : "determinate"
                                                    }
                                                    value={item.progress}
                                                    valueBuffer={item.progress}
                                                    height={"8px"}
                                                    borderRadius={"2px"}
                                                    backgroundColor={"#E0E0E0"}
                                                    barbackgroundColor={
                                                      item.visible
                                                        ? "red"
                                                        : "#7F56D9"
                                                    }
                                                    dashedmarginTop={"2px"}
                                                    dashedbackgroundImage={
                                                      item.visible
                                                        ? "radial-gradient(rgb(255 46 0) 0%, rgb(255 0 0) 16%, #00000000 42%)"
                                                        : "radial-gradient(rgb(82 0 255) 0%, rgb(82 0 255) 16%, #00000000 42%)"
                                                    }
                                                  />
                                                  <Typography
                                                    color="#344054"
                                                    fontSize={"12px"}
                                                    fontWeight={500}
                                                  >
                                                    {item.progress}%
                                                  </Typography>
                                                </StyledLinearContainer>

                                                {item.visible && (
                                                  <CustomTooltipField
                                                    size={7}
                                                    fontWeight={600}
                                                  >
                                                    {"Something went wrong"}
                                                  </CustomTooltipField>
                                                )}
                                              </CustomDiv>
                                            </CommonGrid2>
                                          </FileContainer>
                                        ))}
                                    </Card>
                                  )}
                                </Draggable>
                              );
                            }
                          )
                        )}
                        {provided.placeholder}
                      </Box>
                    </Box>
                  );
                }}
              </Droppable>
            );
          })}
        </CommonGrid2>
      </DragDropContext>

      <ShareQuickMatch
        title="Share Job Description"
        shareDialogOpen={shareDialogOpen.open}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        isLoading={shareDialogOpen.loading}
        condition={true}
        statusOptions={statusOptions}
        CustomMenuItem={CustomMenuItem}
      />

      <AddMoreCandidate
        addMoreCandidateDialogOpen={uploadFile.open}
        handleAddMoreCandidateDialogClose={handleAddMoreCandidateDialogClose}
        handleAddMoreCandidateDragOver={handleAddMoreCandidateDragOver}
        handleAddMoreCandidateDragLeave={handleAddMoreCandidateDragLeave}
        handleAddMoreCandidateDrop={handleAddMoreCandidateDrop}
        handleAddMoreCandidateFileUpload={handleAddMoreCandidateFileUpload}
        addMoreCandidateFiles={uploadFile.files}
        isAddMoreCandidateDragging={uploadFile.drag}
        handleAddMoreCandidateDeleteFile={handleAddMoreCandidateDeleteFile}
        handleAddMoreCandidateClick={handleUploadClick}
        isLoading={uploadFile.loading}
        isJem={false}
        // disabled={addMoreCandidateFiles?.length >= 1}
        disabled={uploadFile.loading}
        buttonDisabled={uploadFile.loading}
        title={"Upload Files"}
        buttonName="Add"
      />

      <DialogCandidateHub
        open={selectDialog.open}
        handleButttonClose={handleChangeStatusClose}
        icon={<StatusChangeIco margin={"10px 0px 0px 10px"} />}
        footer={<ChangeStatusFooter />}
        title={"Change Status"}
        titlepadding={"0rem 0px 0px"}
        content={handleContent()}
      />

      <DialogCandidateHub
        open={pausePlayDialog.open}
        handleButttonClose={handleChangePausePlayClose}
        icon={<StatusChangeIco margin={"10px 0px 0px 10px"} />}
        footer={<PausePlayFooter />}
        title={"Action"}
        titlepadding={"0rem 0px 10px"}
        content={pausePlayDialog.content}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
    </CustomDiv>
  );
}
